module.exports = __webpack_public_path__ + "img/DSC_0770.87bc7962.jpeg";